export default __webpack_public_path__ + "static/media/SAPLogo.ffb14fc5.svg";